/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NDCDialog.vue?vue&type=template&id=2102c644"
import script from "./NDCDialog.vue?vue&type=script&lang=js"
export * from "./NDCDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2102c644')) {
      api.createRecord('2102c644', component.options)
    } else {
      api.reload('2102c644', component.options)
    }
    module.hot.accept("./NDCDialog.vue?vue&type=template&id=2102c644", function () {
      api.rerender('2102c644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/NDCDialog.vue"
export default component.exports